import { useState, useCallback, useEffect } from 'react';
import { Grid, TableCell, TableHead, TableRow, Typography, Table, TableBody, TableContainer, Paper, TablePagination, Button } from '@mui/material';
import { DateTimePicker, TextField, SelectField, Dialog } from 'style-guide';
import { useDispatch, useSelector } from 'react-redux';
import ServiceProviderTable from 'serviceProvider/ServiceProviderTable';
import AddServiceProvider from './AddServiceProvider';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';
import { onFunctionChange } from 'reducers/order-reducers/predefinedDataSlicer';
import { addShipper, updateShipper, onPickupAddressChange } from 'reducers/shippersSlicer';
import { addCustomer } from 'reducers/customersSlicer';
import { addConsignee, updateConsignee } from 'reducers/consigneesSlicer';
import { addVendor, updateVendor, add, updateServiceProviders } from 'reducers/VendorSlicer';
import { addTruckingCompany, updateTruckingCompany } from 'reducers/TruckingCompanySlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import RowCustomer from './RowCustomer';
import { onShippersChange } from 'reducers/shippersSlicer';
import { onCustomersChange } from 'reducers/customersSlicer';
import { onConsigneesChange } from 'reducers/consigneesSlicer';
import { onTruckingCompaniesChange } from 'reducers/TruckingCompanySlicer';
import { onVendorsChange, onAllChange } from 'reducers/VendorSlicer';
import { onUsersLocationChange } from 'reducers/UsersSlicer';
import * as XLSX from 'xlsx';

import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const Customers = ({ loginUser }) => {
    const dispatch = useDispatch();
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const [completed, setCompleted] = useState(false);
    const { all } = useSelector(state => state.vendors);
    const [companyName, setCompanyName] = useState("");
    const [cityName, setCityName] = useState("");
    const [aCode, setACode] = useState("0");
    const [countryId, setCountryId] = useState(31);
    const [countryName, setCountryName] = useState("Country");
    const [phoneNo, setPhoneNo] = useState("");
    const [contactName, setContactName] = useState("");
    const [emailName, setEmailName] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [commercial, setCommercial] = useState("");
    const [reminderText, setReminderText] = useState("");
    const [reminderDate, setReminderDate] = useState("");
    const [reminderDateSearch, setReminderDateSearch] = useState("");
    const [vat, setVat] = useState("");
    const [crmStatus, setCrmStatus] = useState("");
    const crm_states = [{ id: 2, name: "Lead" }, { id: 3, name: "Account" }]
    const [majorFunctionId, setMajorFunctionId] = useState(2);
    const [majorFunctionName, setMajorFunctionName] = useState("Reset");
    const onHandleOpenModal = () => setOpenOrderModal(true);
    const onHandleCancelModal = () => setOpenOrderModal(false);
    const [openImportModal, setOpenImportModal] = useState(false);
    const onHandleImportModal = () => setOpenImportModal(true);
    const onHandleImportCancelModal = () => setOpenImportModal(false);
    const { countryOfOriginData, serviceProviderType, userILNames } = useSelector(state => state.predefinedData);
    const { usersLocation } = useSelector(state => state.users);
    const [csvFile, setCsvFile] = useState();
    const [csvArray, setCsvArray] = useState([]);
    const [totalEntries, setTotalEntries] = useState(0);
    const [consigneeList, setConsigneeList] = useState(0);

    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(50);
    const onPageHandleChange = (_, newPage) => {
        setPage(newPage);
    };
    const onRowsPerPageHandleChange = event => {
        setSize(+event.target.value);
        setPage(0);
    };
    const [pickupAddressCount, setPickupAddressCount] = useState(0);
    const [allCount, setAllCount] = useState(0);
    useEffect(() => {
        /*sendRequest(`/api/serviceProvider/count/5?loginUserType=${loginUser?.authorities && loginUser?.authorities[0]?.authority}&companyName=${companyName}&cityName=${cityName}&phoneNo=${phoneNo}&contactName=${contactName}&countryId=${countryId}&emailName=${emailName}&contactPhone=${contactPhone}&majorFunctionId=${majorFunctionId}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => setPickupAddressCount(response),
            failedCallback,
        });*/
        //sendRequest(`/api/serviceProvider/count`, REQUEST_ACTIONS.GET, '', {
        sendRequest(`/api/serviceProvider/searchCountCrm?loginUserType=${loginUser?.authorities && loginUser?.authorities[0]?.authority}&companyName=${companyName?.trim()}&cityName=${cityName?.trim()}&phoneNo=${phoneNo?.trim()}&contactName=${contactName?.trim()}&countryId=${countryId}&emailName=${emailName?.trim()}&contactPhone=${contactPhone?.trim()}&majorFunctionId=${majorFunctionId}&vat=${vat?.trim()}&crmStatus=${crmStatus}&code=${aCode?.trim()}&reminderDate=${reminderDateSearch?.trim()}&reminderText=${reminderText?.trim()}&commercial=${commercial?.trim()}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => setAllCount(response),
            failedCallback,
        });
    }, [all, failedCallback]);
    useEffect(() => {
        // predefined shippers data get
        sendRequest(`/api/serviceProvider/1`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onShippersChange(response)),
            failedCallback,
        });

        sendRequest('/api/locations', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onUsersLocationChange(response)),
            failedCallback
        });

        // predefined consignee data get
        sendRequest(`/api/serviceProvider/2`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                dispatch(onConsigneesChange(response))
            },
            failedCallback,
        });

        sendRequest(`/api/serviceProvider/3`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onTruckingCompaniesChange(response)),
            failedCallback,
        });

        sendRequest(`/api/serviceProvider/4?size=${size}&page=${page}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onVendorsChange(response)),
            failedCallback,
        });

        // predefined customers data get
        sendRequest(`/api/serviceProvider/13`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onCustomersChange(response)),
            failedCallback,
        });
        if (companyName || cityName || phoneNo || contactName || countryId || emailName || contactPhone || majorFunctionId) {
            sendRequest(`/api/serviceProvider/searchCrm?loginUserType=${loginUser?.authorities && loginUser?.authorities[0]?.authority}&companyName=${companyName?.trim()}&cityName=${cityName?.trim()}&phoneNo=${phoneNo?.trim()}&contactName=${contactName?.trim()}&countryId=${countryId}&emailName=${emailName?.trim()}&contactPhone=${contactPhone?.trim()}&majorFunctionId=${majorFunctionId}&size=${size}&page=${page}&vat=${vat?.trim()}&crmStatus=${crmStatus}&code=${aCode?.trim()}&reminderDate=${reminderDateSearch?.trim()}&reminderText=${reminderText?.trim()}&commercial=${commercial?.trim()}`, REQUEST_ACTIONS.GET, '', {
                successCallback: response => dispatch(onAllChange(response)),
                failedCallback,
            });
        } else {
            sendRequest(`/api/serviceProvider?loginUserType=${loginUser?.authorities && loginUser?.authorities[0]?.authority}&size=${size}&page=${page}`, REQUEST_ACTIONS.GET, '', {
                successCallback: response => dispatch(onAllChange(response)),
                failedCallback,
            });
        }
    }, [page, size, dispatch, failedCallback]);

    const setCountry = (id) => {
        if (id == null) {
            setCountryName("");
            setCountryId(-1);
            return;
        }
        var ctr = countryOfOriginData.find(c => c.id == id)
        if (ctr) {
            setCountryName(ctr.name);
            setCountryId(ctr.id);
        } else {
            setCountryName("");
            setCountryId(-1);
        }
    }
    const onSearch = () => {
        //
        sendRequest(`/api/serviceProvider/searchCrm?loginUserType=${loginUser?.authorities && loginUser?.authorities[0]?.authority}&companyName=${companyName?.trim()}&cityName=${cityName?.trim()}&phoneNo=${phoneNo?.trim()}&contactName=${contactName?.trim()}&countryId=${countryId}&emailName=${emailName?.trim()}&contactPhone=${contactPhone?.trim()}&majorFunctionId=${majorFunctionId}&size=${size}&page=${page}&vat=${vat?.trim()}&crmStatus=${crmStatus}&code=${aCode?.trim()}&reminderDate=${reminderDateSearch?.trim()}&reminderText=${reminderText?.trim()}&commercial=${commercial?.trim()}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onAllChange(response)),
            failedCallback,
        });
    }

    const processCSV = (str1, delim = ',') => {
        const str2 = str1.replace("\r", "");
        const str = str2.replace("\\r", "");
        const headers = str.slice(0, str.indexOf('\n')).split(delim);
        const rows = str.slice(str.indexOf('\n') + 1).split('\n');
        setTotalEntries(rows.length);
        const newArray = rows.map((row1, index) => {
            setTimeout(() => {
                const row2 = row1.replace("\r", "");
                const row = row2.replace("\\r", "");
                const values = row.split(delim);
                if (values.length < 3) { return null; }
                var skip = false;
                const eachObject = headers.reduce((obj, header, i) => {
                    if (header === "countryId") {
                        const len = countryOfOriginData.length;
                        var exists = false;
                        var id = 0;
                        for (var j = 0; j < len; j++) {
                            if (countryOfOriginData[j].name == values[i] && !exists) { exists = true; id = countryOfOriginData[j].id; break; }
                        }
                        if (exists) { obj[header] = id; }
                        else { skip = true; }
                    }
                    else if (header === "serviceProviderTypeId") {
                        const len = serviceProviderType.length
                        for (var j = 0; j < len; j++) {
                            if (serviceProviderType[j].name == values[i] && !exists) { exists = true; id = serviceProviderType[j].id; break; }
                        }
                        if (exists) { obj[header] = id; }
                        else { obj[header] = 1; }
                    }
                    else if (header === "serviceProviderTypeId1") {
                        const len = serviceProviderType.length
                        for (var j = 0; j < len; j++) {
                            if (serviceProviderType[j].name == values[i] && !exists) { exists = true; id = serviceProviderType[j].id; break; }
                        }
                        if (exists) { obj[header] = id; }
                        else { obj[header] = 3; }
                    }
                    else { obj[header] = values[i]; }
                    return obj;
                }, {})
                if (!skip) {
                    try { save(eachObject, index); }
                    catch (error) { }
                }
                else { }
                return eachObject;
            }, 200 * index)
        })
        setCsvArray(newArray);
    }
    const submit = (cfile) => {
        const file = cfile;
        const reader = new FileReader();

        reader.onload = function (e) {
            const text = e.target.result;
            //console.log(text);
            processCSV(text)
        }
        reader.readAsText(file);
    }
    const save = (item, index) => {
        item.functionsId = null;
        item.sameAsShipper = "sameAsShipper";
        item.pickupAddress = null;
        sendRequest('/api/serviceProvider', REQUEST_ACTIONS.POST, item, {
            successCallback: response => {
                if (response.id == -100) { dispatch(snackbarToggle({ type: 'error', message: response.companyName + ' already exists. index: ' + index })); }
                if (response.serviceProviderTypeId === 1) {
                    dispatch(addShipper(response));
                    dispatch(onPickupAddressChange(null));
                } else if (response.serviceProviderTypeId === 2) {
                    dispatch(addConsignee(response));
                    dispatch(onPickupAddressChange(null));
                } else if (response.serviceProviderTypeId === 4) {
                    dispatch(addVendor(response));
                } else if (response.serviceProviderTypeId === 13) {
                    dispatch(addCustomer(response));
                } else {
                    dispatch(addTruckingCompany(response));
                }
                dispatch(add(response));
            },
            failedCallback,
        });
        if (index >= totalEntries - 3) { onHandleImportCancelModal(); }

    };


    useEffect(() => {
        sendRequest('/api/function', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                dispatch(onFunctionChange(response.filter(functions => functions.name !== 'new pickup Address')));
                setCompleted(true);
            },
            failedCallback,
        });
    }, [dispatch, failedCallback]);

    const [userILImporter, setUserILImporter] = useState([]);
    const [userILTracer, setUserILTracer] = useState([]);
    const [userILCustoms, setUserILCustoms] = useState([]);
    const [userILSales, setUserILSales] = useState([]);

    useEffect(() => {
        var importers = [];
        var tracers = [];
        var customs = [];
        var sales = [];

        importers = userILNames.filter(name => name.department == 1 || name.department == null);
        tracers = userILNames.filter(name => name.department == 2);
        customs = userILNames.filter(name => name.department == 3);
        sales = userILNames.filter(name => name.department == 4);

        setUserILImporter(importers);
        setUserILTracer(tracers);
        setUserILCustoms(customs);
        setUserILSales(sales);
    }, []);
    function formatDate(date) {
        if (!date)
            return "";
        let p = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            // second: '2-digit',
            hour12: false,
            timeZone: 'UTC',
            // timeZoneName: "longOffset",
        }).format(date)
        return p

        return `${p.day}/${p.month}/${p.year}, ${p.hour}:${p.minute}:${p.second} ${p.dayPeriod} `;
    }

    const getDate = (date) => {
        var sp = date.split("T")[0].split("-");
        return sp[2] + "/" + sp[1] + "/" + sp[0];
    }
    const exportConsignees = () => {
        // predefined consignee data get
        sendRequest(`/api/serviceProvider/searchCrm?loginUserType=${loginUser?.authorities && loginUser?.authorities[0]?.authority}&companyName=${companyName?.trim()}&cityName=${cityName?.trim()}&phoneNo=${phoneNo?.trim()}&contactName=${contactName?.trim()}&countryId=${countryId}&emailName=${emailName?.trim()}&contactPhone=${contactPhone?.trim()}&majorFunctionId=${majorFunctionId}&size=50000&page=0&vat=${vat?.trim()}&crmStatus=${crmStatus}&code=${aCode?.trim()}&reminderDate=${reminderDateSearch?.trim()}&reminderText=${reminderText?.trim()}&commercial=${commercial?.trim()}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var items = [];
                var headers = ["NAME", "VAT", "COUNTRY", "STATE", "CITY", "ADDRESS", "ZIP CODE", "LOCATION", "STATUS", "SALESMAN", "LOCAL NAME",
                    "FAX", "PHONE", "AREA CODE", "DATE OF BIRTH", "SALES USER", "FU USER", "OPS USER", "CUSTOMS USER"];
                for (var i = 0; i < response.length; i++) {
                    var value = response[i];
                    try {
                        items.push({
                            "NAME": value.companyName,
                            "VAT": value.uatnumber ? value.uatnumber : "",
                            "COUNTRY": countryOfOriginData.find(u => u.id === value.countryId)?.name || '',
                            "STATE": value.state ? value.state : "",
                            "CITY": value.city ? value.city : "",
                            "ADDRESS": (value.address1 ? value.address1 : "") + " " + (value.address2 ? value.address2 : ""),
                            "ZIP CODE": value.zipCode ? value.zipCode : "",
                            "LOCATION": usersLocation.find(ul => ul.id == value.serviceProviderLocationId)?.name,
                            "STATUS": value.crmStatus ? (value.crmStatus == 2 ? "LEAD" : "ACCOUNT") : "",
                            "SALESMAN": value.salesman ? value.salesman : "",
                            "LOCAL NAME": value.localName ? value.localName : "",
                            "FAX": value.fax ? value.fax : "",
                            "PHONE": value.phone ? value.phone : "",
                            "AREA CODE": value.code ? value.code : "",
                            "DATE OF BIRTH": value.dob ? value.dob : "",
                            "SALES USER": userILSales.find(u => u.id == value.suser)?.name,
                            "FU USER": userILImporter.find(u => u.id == value.iuser)?.name,
                            "OPS USER": userILTracer.find(u => u.id == value.ouser)?.name,
                            "CUSTOMS USER": userILCustoms.find(u => u.id == value.cuser)?.name,
                            "REMINDER DATE": value.reminderDate ? new Date(value.reminderDate) : null,
                            "REMINDER TEXT": value.reminderText,
                            "COMMERCIAL": value.commercial,
                            "COMMENTS": value.coments,
                        });
                    } catch (e) {
                        console.log(e)
                    }

                }
                jsonToExcel(items, "CRM_" + formatDate(new Date()), headers)
                //dispatch(onConsigneesChange(response))
            },
            failedCallback,
        });
        /*sendRequest('/api/serviceProvider/2?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var items = [];
                var headers = ["NAME", "VAT", "COUNTRY", "STATE", "CITY", "ADDRESS", "ZIP CODE", "LOCATION", "STATUS", "SALESMAN", "LOCAL NAME",
                    "FAX", "PHONE", "AREA CODE", "DATE OF BIRTH", "SALES USER", "FU USER", "OPS USER", "CUSTOMS USER"];
                for (var i = 0; i < response.length; i++) {
                    var value = response[i];
                    try {
                        items.push({
                            "NAME": value.companyName,
                            "VAT": value.uatnumber ? value.uatnumber : "",
                            "COUNTRY": countryOfOriginData.find(u => u.id === value.countryId)?.name || '',
                            "STATE": value.state ? value.state : "",
                            "CITY": value.city ? value.city : "",
                            "ADDRESS": (value.address1 ? value.address1 : "") + " " + (value.address2 ? value.address2 : ""),
                            "ZIP CODE": value.zipCode ? value.zipCode : "",
                            "LOCATION": usersLocation.find(ul => ul.id == value.serviceProviderLocationId)?.name,
                            "STATUS": value.crmStatus ? (value.crmStatus == 2 ? "LEAD" : "ACCOUNT") : "",
                            "SALESMAN": value.salesman ? value.salesman : "",
                            "LOCAL NAME": value.localName ? value.localName : "",
                            "FAX": value.fax ? value.fax : "",
                            "PHONE": value.phone ? value.phone : "",
                            "AREA CODE": value.code ? value.code : "",
                            "DATE OF BIRTH": value.dob ? value.dob : "",
                            "SALES USER": userILSales.find(u => u.id == value.suser)?.name,
                            "FU USER": userILImporter.find(u => u.id == value.iuser)?.name,
                            "OPS USER": userILTracer.find(u => u.id == value.ouser)?.name,
                            "CUSTOMS USER": userILCustoms.find(u => u.id == value.cuser)?.name,
                        });
                    } catch (e) {
                        console.log(e)
                    }

                }
                jsonToExcel(items, "CRM_" + formatDate(new Date()), headers)
                //dispatch(onConsigneesChange(response))
            },
            failedCallback,
        });*/
    }

    const jsonToExcel = function (data, name, header) {
        var ws = XLSX.utils.json_to_sheet(data, header);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");
        XLSX.writeFile(wb, name + ".xlsx");
    }
    return (
        completed && (
            <Grid item container justifyContent="flex-end">
                {/*<Grid container item xs={12} justifyContent='space-evenly' style={{ marginBottom: "5px" }}>
                    <Button onClick={exportConsignees} variant='contained'>
                        {`Export Customers`}
                    </Button>
                    <Button onClick={onHandleOpenModal} variant='contained'>
                        {`+ New Customer`}
                    </Button>
                    {openOrderModal && (
                        <Dialog
                            maxWidth='md'
                            open={openOrderModal}
                            title={`New Customer`}
                            onHandleCancel={onHandleCancelModal}>
                            <AddServiceProvider onHandleCancel={() => setOpenOrderModal(false)} id={null} readOnly={false} consigneeList={consigneeList} />
                        </Dialog>
                    )}
                </Grid>*/}
                <TableContainer sx={{ maxHeight: 'calc(100vh - 170px)' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={{ width: "8%" }}>
                                    <TextField
                                        lg={null}
                                        md={null}
                                        sm={null}
                                        value={companyName}
                                        onChange={event => setCompanyName(event.target.value)}
                                        label='Company Name'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "8%" }}>
                                    <TextField
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        value={cityName}
                                        onChange={event => setCityName(event.target.value)}
                                        label='City'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "4%" }}>
                                    <TextField
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        value={aCode}
                                        onChange={event => setACode(event.target.value)}
                                        label='Area'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "8%" }}>
                                    <TextField
                                        lg={null}
                                        md={null}
                                        sm={null}
                                        value={contactName}
                                        onChange={event => setContactName(event.target.value)}
                                        label='Contact Name'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "6%" }}>
                                    <TextField
                                        lg={null}
                                        md={null}
                                        sm={null}
                                        value={phoneNo}
                                        onChange={event => setPhoneNo(event.target.value)}
                                        label='Phone'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "6%" }}>
                                    <TextField
                                        lg={null}
                                        md={null}
                                        sm={null}
                                        value={contactPhone}
                                        onChange={event => setContactPhone(event.target.value)}
                                        label='Mobile'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "32%" }}>
                                    <TextField
                                        lg={null}
                                        md={null}
                                        sm={null}
                                        value={reminderText}
                                        onChange={event => setReminderText(event.target.value)}
                                        label='Reminder Text'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "6%" }}>
                                    <DateTimePicker
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        label='Reminder Date'
                                        boldLabel={<Typography fontSize="0.8vw" fontWeight='bold'>Reminder</Typography>}
                                        value={reminderDate}
                                        format="dd/MM/yyyy"
                                        isShowTime={false}
                                        onChange={(date) => {
                                            if (date) {
                                                const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
                                                const getTimezoneOffset = (date) => {
                                                    const tzOffset = -date.getTimezoneOffset(); // getTimezoneOffset returns a negative value for positive offsets
                                                    const diff = tzOffset >= 0 ? '+' : '-';
                                                    return diff + pad(tzOffset / 60) + ':' + pad(tzOffset % 60);
                                                };
                                                const formatLocalISO = (date) => {
                                                    let isoDate = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
                                                    isoDate += 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
                                                    // Append milliseconds if needed
                                                    // isoDate += '.' + String(date.getMilliseconds()).padStart(3, '0'); 
                                                    return isoDate + getTimezoneOffset(date);
                                                };
                                                console.log(formatLocalISO(date))
                                                setReminderDate(formatLocalISO(date))
                                                setReminderDateSearch(formatLocalISO(date).split("T")[0])
                                            } else {
                                                setReminderDate("")
                                                setReminderDateSearch("")
                                            }
                                        }}
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "8%" }}>
                                    <TextField
                                        lg={null}
                                        md={null}
                                        sm={null}
                                        value={commercial}
                                        onChange={event => setCommercial(event.target.value)}
                                        label='Commercial'
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "6%" }}>
                                    <SelectField
                                        inputLabelTop={0}
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        label="Status"
                                        value={crmStatus}
                                        onChange={event => setCrmStatus(event.target.value)}
                                        options={[{ id: null, name: 'Reset' }, ...crm_states]}
                                    />
                                </TableCell>
                                <TableCell colSpan={1} style={{ width: "8%" }}>
                                    <Grid item container spacing={1} justifyContent="center" style={{minWidth: "75px"}}>
                                        <ManageSearchIcon onClick={onSearch} />
                                        <FileDownloadIcon onClick={exportConsignees} />
                                        {/*<Button onClick={onSearch} variant='contained'>
                                            <ManageSearchIcon onClick={onSearch} />
                                        </Button>
                                        <Button onClick={exportConsignees} variant='contained' style={{marginLeft:"5px"}}>
                                            <FileDownloadIcon />
                                        </Button>*/}
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {all.map(shipper => (
                                <RowCustomer key={shipper?.id || uuidv4()} type={shipper.serviceProviderTypeId} data={shipper} consigneeList={consigneeList} loginUser={loginUser} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component='div'
                    count={allCount - pickupAddressCount}
                    rowsPerPage={size}
                    page={page}
                    onPageChange={onPageHandleChange}
                    onRowsPerPageChange={onRowsPerPageHandleChange}
                />
            </Grid>
        )
    );
};

export default Customers;
